export const sortBySeverity = <T extends { severity: string }>(a: T, b: T) => {
  const weights: Record<string, number> = {
    '-1': 2,
    1: 1,
  };
  return (weights[b.severity] || 0) - (weights[a.severity] || 0);
};
